var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "page-outline",
        {
          attrs: {
            title: _vm.$t("Webheader.injection_unit"),
            accessibilityCompliant: true,
          },
        },
        [
          _c("template", { slot: "pageContent" }, [
            _c(
              "div",
              { attrs: { slot: "pageContent" }, slot: "pageContent" },
              [
                _vm.formErrors.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "alert alert-danger border-2 p-3 mb-3",
                        attrs: {
                          id: "error-summary",
                          role: "alert",
                          "aria-live": "assertive",
                          tabindex: "-1",
                        },
                      },
                      [
                        _c("h2", { staticClass: "h5 text-dark mb-2" }, [
                          _vm._v(_vm._s(_vm.$t("errors.error_summary"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "mb-0 ps-3" },
                          _vm._l(_vm.formErrors, function (error) {
                            return _c("li", { key: error.field }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-dark text-decoration-underline",
                                  attrs: { href: "#" + error.field },
                                },
                                [_vm._v(_vm._s(error.message))]
                              ),
                            ])
                          }),
                          0
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "form-accordion",
                      {
                        attrs: {
                          toggleActive: false,
                          title: _vm.$t("tracking.general_information"),
                          isTitleUpperCase: false,
                        },
                      },
                      [
                        _c("h2", { staticClass: "sr-only" }, [
                          _vm._v(
                            _vm._s(_vm.$t("tracking.general_information"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          {
                            staticClass:
                              "d-flex justify-content-center align-items-center",
                          },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "mb-3",
                                attrs: { cols: "12", sm: "6" },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "tracking.please_enter_iban_to_verify"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    inputLabel:
                                      _vm.$t("tracking.iban") +
                                      " " +
                                      _vm.$t("tracking.to_check"),
                                    descLabel: _vm.$t(
                                      "tracking.iban_description"
                                    ),
                                    placeholderValue: _vm.$t("tracking.iban"),
                                    inputId: "iban-input",
                                    autocomplete: "off",
                                  },
                                  model: {
                                    value: _vm.form.iban,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "iban", $$v)
                                    },
                                    expression: "form.iban",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "mb-3",
                                attrs: { cols: "12", sm: "6" },
                              },
                              [
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _vm.verifierIBAN(_vm.form.iban) &&
                                _vm.form.iban != "" &&
                                _vm.corporateIdentifierTypesMatch
                                  ? _c("form-write-group-label-input", {
                                      attrs: {
                                        inputLabel:
                                          _vm.$t("tracking.reference"),
                                        placeholderValue:
                                          _vm.$t("tracking.reference"),
                                        inputId: "reference-input",
                                      },
                                      model: {
                                        value: _vm.form.reference,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "reference", $$v)
                                        },
                                        expression: "form.reference",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.ibanFind
                      ? _c(
                          "form-accordion",
                          {
                            attrs: {
                              toggleActive: true,
                              title: _vm.$t(
                                "tracking.information_retrieved_from_iban"
                              ),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _c("h2", { staticClass: "sr-only" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "tracking.information_retrieved_from_iban"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              {
                                staticClass:
                                  "d-flex justify-content-center align-items-start",
                              },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { cols: "12", md: "6", lg: "4" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-table-container border rounded",
                                        attrs: {
                                          tabindex: "0",
                                          role: "region",
                                          "aria-label":
                                            _vm.$t("tracking.valid_iban") +
                                            " - " +
                                            _vm.$t("common.scrollable_table"),
                                        },
                                      },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticClass:
                                              "table table-bordered table-sm text-center mb-0",
                                          },
                                          [
                                            _c(
                                              "caption",
                                              {
                                                staticClass:
                                                  "text-center bg-dark text-white p-2 mb-0",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.valid_iban"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("thead", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  {
                                                    attrs: {
                                                      id: "verification-type-1",
                                                      scope: "col",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tracking.verification_type"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  {
                                                    attrs: {
                                                      id: "verification-status-1",
                                                      scope: "col",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tracking.status"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c(
                                                "tr",
                                                { staticClass: "bg-light" },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                      attrs: { scope: "row" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tracking.iban_format_verification"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.format == "$Match"
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle table-success text-dark fw-bold",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-check-circle me-1",
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true",
                                                            },
                                                          }),
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.valid"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle table-danger text-dark fw-bold",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-times-circle me-1",
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true",
                                                            },
                                                          }),
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.invalid"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "tr",
                                                { staticClass: "bg-light" },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                      attrs: { scope: "row" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tracking.account_key_verification"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.keyIban == "$Match"
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle table-success text-dark fw-bold",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-check-circle me-1",
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true",
                                                            },
                                                          }),
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.valid"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle table-danger text-dark fw-bold",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-times-circle me-1",
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true",
                                                            },
                                                          }),
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.invalid"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "tr",
                                                { staticClass: "bg-light" },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                      attrs: { scope: "row" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tracking.iban_key_verification"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.keyBBAN == "$Match"
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle table-success text-dark fw-bold",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-check-circle me-1",
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true",
                                                            },
                                                          }),
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.valid"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle table-danger text-dark fw-bold",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-times-circle me-1",
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true",
                                                            },
                                                          }),
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.invalid"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  {
                                                    staticClass: "align-middle",
                                                    attrs: { scope: "row" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tracking.bank_reachable"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.corporateIdentifierTypesMatch
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "align-middle table-success text-dark fw-bold",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-check-circle me-1",
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true",
                                                          },
                                                        }),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.reachable"
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "align-middle table-danger text-dark fw-bold",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-times-circle me-1",
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true",
                                                          },
                                                        }),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.unreachable"
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { cols: "12", md: "6", lg: "4" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-table-container border rounded",
                                        attrs: {
                                          tabindex: "0",
                                          role: "region",
                                          "aria-label":
                                            _vm.$t(
                                              "tracking.bank_domiciliation"
                                            ) +
                                            " - " +
                                            _vm.$t("common.scrollable_table"),
                                        },
                                      },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticClass:
                                              "table table-bordered table-sm text-center mb-0",
                                          },
                                          [
                                            _c(
                                              "caption",
                                              {
                                                staticClass:
                                                  "text-center bg-dark text-white p-2 mb-0",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.bank_domiciliation"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("thead", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  {
                                                    attrs: {
                                                      id: "bank-info-type",
                                                      scope: "col",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tracking.information_type"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  {
                                                    attrs: {
                                                      id: "bank-info-value",
                                                      scope: "col",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("tracking.value")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c(
                                                "tr",
                                                { staticClass: "bg-light" },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                      attrs: { scope: "row" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tracking.institution_name"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.institutionName !== "" &&
                                                  _vm.institutionName !==
                                                    "$NotFound"
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                          attrs: {
                                                            id: "InstitutionName",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.institutionName
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                        },
                                                        [_vm._v("-")]
                                                      ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "tr",
                                                { staticClass: "bg-light" },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                      attrs: { scope: "row" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tracking.branch_information"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.branchInformation !==
                                                    "" &&
                                                  _vm.branchInformation !==
                                                    "$NotFound"
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                          attrs: {
                                                            id: "BranchInformation",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.branchInformation
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                        },
                                                        [_vm._v("-")]
                                                      ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "tr",
                                                { staticClass: "bg-light" },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                      attrs: { scope: "row" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tracking.address_line_1"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.address1 !== "" &&
                                                  _vm.address1 !== "$NotFound"
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                          attrs: {
                                                            id: "StreetAddress1",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(_vm.address1)
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                        },
                                                        [_vm._v("-")]
                                                      ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.address2 !== "" &&
                                              _vm.address2 !== "$NotFound"
                                                ? _c(
                                                    "tr",
                                                    {
                                                      staticStyle: {
                                                        "background-color":
                                                          "#F9F9F9",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                          attrs: {
                                                            scope: "row",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "tracking.address_line_2"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                          attrs: {
                                                            id: "StreetAddress2",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(_vm.address2)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.address3 !== "" &&
                                              _vm.address3 !== "$NotFound"
                                                ? _c(
                                                    "tr",
                                                    {
                                                      staticStyle: {
                                                        "background-color":
                                                          "#F9F9F9",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                          attrs: {
                                                            scope: "row",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "tracking.address_line_3"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                          attrs: {
                                                            id: "StreetAddress3",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(_vm.address3)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.address4 !== "" &&
                                              _vm.address4 !== "$NotFound"
                                                ? _c(
                                                    "tr",
                                                    {
                                                      staticStyle: {
                                                        "background-color":
                                                          "#F9F9F9",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                          attrs: {
                                                            scope: "row",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "tracking.address_line_4"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                          attrs: {
                                                            id: "StreetAddress4",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(_vm.address4)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "tr",
                                                { staticClass: "bg-light" },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                      attrs: { scope: "row" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tracking.zip_and_city"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  (_vm.zipCode !== "" &&
                                                    _vm.zipCode !==
                                                      "$NotFound") ||
                                                  (_vm.city !== "" &&
                                                    _vm.city !== "$NotFound")
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                          attrs: {
                                                            id: "ZipCodeCity",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                id: "ZipCode",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.zipCode
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c("span", [
                                                            _vm._v(" "),
                                                          ]),
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                id: "City",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(_vm.city)
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                        },
                                                        [_vm._v("-")]
                                                      ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.Cps !== "" &&
                                              _vm.Cps !== "$NotFound"
                                                ? _c(
                                                    "tr",
                                                    {
                                                      staticStyle: {
                                                        "background-color":
                                                          "#F9F9F9",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                          attrs: {
                                                            scope: "row",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "tracking.cps"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                          attrs: { id: "Cps" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(_vm.Cps)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "tr",
                                                { staticClass: "bg-light" },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                      attrs: { scope: "row" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tracking.country_and_iso"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  (_vm.country !== "" &&
                                                    _vm.country !==
                                                      "$NotFound") ||
                                                  (_vm.ISOCountryCode !== "" &&
                                                    _vm.ISOCountryCode !==
                                                      "$NotFound")
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                          attrs: {
                                                            id: "CountryNameAndIso",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                id: "CountryName",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.country
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.ISOCountryCode !==
                                                          "$NotFound"
                                                            ? _c("span", [
                                                                _vm._v("("),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    attrs: {
                                                                      id: "IsoCountryCode",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.ISOCountryCode
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(")"),
                                                              ])
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    : _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-middle",
                                                        },
                                                        [_vm._v("-")]
                                                      ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { cols: "12", md: "6", lg: "4" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-table-container border rounded",
                                        attrs: {
                                          tabindex: "0",
                                          role: "region",
                                          "aria-label":
                                            _vm.$t(
                                              "tracking.iban_composition"
                                            ) +
                                            " - " +
                                            _vm.$t("common.scrollable_table"),
                                        },
                                      },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticClass:
                                              "table table-bordered table-sm text-center mb-0",
                                          },
                                          [
                                            _c(
                                              "caption",
                                              {
                                                staticClass:
                                                  "text-center bg-dark text-white p-2 mb-0",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.iban_composition"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("thead", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  {
                                                    attrs: {
                                                      id: "iban-component-type",
                                                      scope: "col",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tracking.component_type"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  {
                                                    attrs: {
                                                      id: "iban-component-value",
                                                      scope: "col",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("tracking.value")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c(
                                                "tr",
                                                {
                                                  staticStyle: {
                                                    "background-color":
                                                      "#F9F9F9",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                      attrs: { scope: "row" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tracking.bank_code"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.IDBank ===
                                                            "$NotFound"
                                                            ? "-"
                                                            : _vm.IDBank
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "tr",
                                                {
                                                  staticStyle: {
                                                    "background-color":
                                                      "#F9F9F9",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                      attrs: { scope: "row" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tracking.branch_code"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.IDBranch ===
                                                            "$NotFound"
                                                            ? "-"
                                                            : _vm.IDBranch
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "tr",
                                                {
                                                  staticStyle: {
                                                    "background-color":
                                                      "#F9F9F9",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                      attrs: { scope: "row" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tracking.account_number"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.accountNumber ===
                                                            "$NotFound"
                                                            ? "-"
                                                            : _vm.accountNumber
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  {
                                                    staticClass: "align-middle",
                                                    attrs: { scope: "row" },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { attrs: { lang: "en" } },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "tracking.bic"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.parentBic ===
                                                          "$NotFound"
                                                          ? "-"
                                                          : _vm.parentBic
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.verifierIBAN(_vm.form.iban) &&
                    _vm.form.iban !== "" &&
                    _vm.corporateIdentifierTypesMatch
                      ? _c(
                          "form-accordion",
                          {
                            attrs: {
                              toggleActive: false,
                              title: _vm.$t("tracking.data_to_check"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _c("h2", { staticClass: "sr-only" }, [
                              _vm._v(_vm._s(_vm.$t("tracking.data_to_check"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "fieldset",
                              { staticClass: "border-0 m-0 p-0" },
                              [
                                _c(
                                  "legend",
                                  { staticClass: "sr-only fw-bold" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "tracking.enterprise_identification"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center align-items-center",
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-3",
                                        attrs: { cols: "12", sm: "6" },
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for: "identifier-type",
                                              id: "identifier-type-label",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "tracking.type_identifier"
                                                  )
                                                )
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "text-dark" },
                                              [_vm._v(" * ")]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.form
                                                    .entrepriseIdentifierType,
                                                expression:
                                                  "form.entrepriseIdentifierType",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              id: "identifier-type",
                                              required:
                                                _vm.verifierIBAN(
                                                  _vm.form.iban
                                                ) && _vm.form.iban !== "",
                                              disabled:
                                                !_vm.verifierIBAN(
                                                  _vm.form.iban
                                                ) || _vm.form.iban === "",
                                              "aria-describedby":
                                                _vm.hasIdentifierTypeError
                                                  ? "identifier-type-error"
                                                  : null,
                                              "aria-invalid":
                                                _vm.hasIdentifierTypeError
                                                  ? "true"
                                                  : "false",
                                              "aria-required":
                                                _vm.verifierIBAN(
                                                  _vm.form.iban
                                                ) && _vm.form.iban !== ""
                                                  ? "true"
                                                  : "false",
                                              autocomplete: "organization",
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  _vm.form,
                                                  "entrepriseIdentifierType",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              { attrs: { value: "" } },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("common.nme")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              Object.keys(_vm.typeList).filter(
                                                function (elem) {
                                                  return !_vm.typeList[elem]
                                                }
                                              ),
                                              function (type) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: type,
                                                    domProps: { value: type },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(type) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.hasIdentifierTypeError
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-dark small mt-1",
                                                attrs: {
                                                  id: "identifier-type-error",
                                                  role: "alert",
                                                  "aria-live": "polite",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm
                                                        .identifierTypeErrors[0]
                                                        .message
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-3",
                                        attrs: { cols: "12", sm: "6" },
                                      },
                                      [
                                        _c("form-write-group-label-input", {
                                          attrs: {
                                            isMandatory: "",
                                            disabled:
                                              !_vm.verifierIBAN(
                                                _vm.form.iban
                                              ) || _vm.form.iban == "",
                                            inputLabel: _vm.$t(
                                              "tracking.identifier"
                                            ),
                                            placeholderValue: _vm.$t(
                                              "tracking.identifier"
                                            ),
                                            inputId: "identifier-input",
                                            mandatoryErrorIndicator:
                                              _vm.hasIdentifierInputError,
                                          },
                                          model: {
                                            value:
                                              _vm.form.entrepriseIdentifierName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "entrepriseIdentifierName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.entrepriseIdentifierName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", {
                                      staticClass: "mb-3",
                                      attrs: { cols: "12", sm: "6" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mt-4" },
                      [
                        _c("b-col", { attrs: { cols: "12" } }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-lg btn-block w-100",
                              class: {
                                "btn-turquoise":
                                  !_vm.activateSpinner && _vm.isFormValid,
                                "btn-turquoise-disabled":
                                  !_vm.isFormValid || _vm.activateSpinner,
                              },
                              attrs: {
                                type: "button",
                                disabled:
                                  !_vm.isFormValid || _vm.activateSpinner,
                                "aria-busy": _vm.activateSpinner
                                  ? "true"
                                  : "false",
                              },
                              on: { click: _vm.addTracking },
                            },
                            [
                              _vm.activateSpinner
                                ? _c("b-spinner", {
                                    staticStyle: { color: "#ffffff" },
                                    attrs: { small: "" },
                                  })
                                : _c("i", {
                                    staticClass: "fa-light fa-paper-plane",
                                    staticStyle: { color: "#ffffff" },
                                    attrs: { "aria-hidden": "true" },
                                  }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(" ") +
                                  _vm._s(
                                    _vm.$t("common.send_verification_request")
                                  ) +
                                  "\n            "
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }